/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Tool_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "A tool was disabled for the organisation." |
*
* @param {Audit_Details_Tool_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_tool_disabled_desc = /** @type {((inputs?: Audit_Details_Tool_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Tool_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Werkzeug wurde für die Organisation deaktiviert.")
	return /** @type {LocalizedString} */ ("A tool was disabled for the organisation.")
});